import { BasePlaceDetail } from './places';

export enum State {
  AA = 'AA',
  AE = 'AE',
  AK = 'AK',
  AL = 'AL',
  AP = 'AP',
  AR = 'AR',
  AS = 'AS',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  FM = 'FM',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MH = 'MH',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  PW = 'PW',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VI = 'VI',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY',
}

const stringToStateEnumMap: Record<string, State> = {
  AA: State.AA,
  AE: State.AE,
  AK: State.AK,
  AL: State.AL,
  AP: State.AP,
  AR: State.AR,
  AS: State.AS,
  AZ: State.AZ,
  CA: State.CA,
  CO: State.CO,
  CT: State.CT,
  DC: State.DC,
  DE: State.DE,
  FL: State.FL,
  FM: State.FM,
  GA: State.GA,
  GU: State.GU,
  HI: State.HI,
  IA: State.IA,
  ID: State.ID,
  IL: State.IL,
  IN: State.IN,
  KS: State.KS,
  KY: State.KY,
  LA: State.LA,
  MA: State.MA,
  MD: State.MD,
  ME: State.ME,
  MH: State.MH,
  MI: State.MI,
  MN: State.MN,
  MO: State.MO,
  MP: State.MP,
  MS: State.MS,
  MT: State.MT,
  NC: State.NC,
  ND: State.ND,
  NE: State.NE,
  NH: State.NH,
  NJ: State.NJ,
  NM: State.NM,
  NV: State.NV,
  NY: State.NY,
  OH: State.OH,
  OK: State.OK,
  OR: State.OR,
  PA: State.PA,
  PR: State.PR,
  PW: State.PW,
  RI: State.RI,
  SC: State.SC,
  SD: State.SD,
  TN: State.TN,
  TX: State.TX,
  UT: State.UT,
  VA: State.VA,
  VI: State.VI,
  VT: State.VT,
  WA: State.WA,
  WI: State.WI,
  WV: State.WV,
  WY: State.WY,
};

export interface Address {
  address?: string | null;
  unitNumber?: string | null;
  city?: string | null;
  state?: State | null;
  zip?: string | null;
  longitude?: number | null;
  latitude?: number | null;
}

export const stringToStateEnum = (stateString: string): State => {
  return stringToStateEnumMap[stateString];
};

export interface VerifyResponse {
  missingUnit?: boolean;
  error?: string;
  address?: BasePlaceDetail;
}
